import { render, staticRenderFns } from "./TabelaAvaliacaoTreinamento.vue?vue&type=template&id=24d83e91&scoped=true"
import script from "./TabelaAvaliacaoTreinamento.vue?vue&type=script&lang=js"
export * from "./TabelaAvaliacaoTreinamento.vue?vue&type=script&lang=js"
import style0 from "./TabelaAvaliacaoTreinamento.vue?vue&type=style&index=0&id=24d83e91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d83e91",
  null
  
)

export default component.exports